function Socials() {
    return (
        <div className="socials flex gap-5 mt-2 text-2xl w-min">
            <a className="hover:scale-110 hover:text-[#ba7ce6] ease-in-out duration-300" href="mailto:tarikabirch@gmail.com">
                <i className="fa fa-envelope"></i>
            </a>
            <a className="hover:scale-110 hover:text-[#ba7ce6] ease-in-out duration-300" href="https://github.com/taigati">
                <i className="fa-brands fa-github"></i>
            </a>
            <a className="hover:scale-110 hover:text-[#ba7ce6] ease-in-out duration-300" href="https://www.linkedin.com/in/tarika-birch/">
                <i className="fa-brands fa-linkedin"></i>
            </a>
            <a className="hover:scale-110 hover:text-[#ba7ce6] ease-in-out duration-300" href="https://medium.com/@tarikabirch">
                <i className="fa-brands fa-medium"></i>
            </a>
            <a className="hover:scale-110 hover:text-[#ba7ce6] ease-in-out duration-300" href="http://www.youtube.com/channel/UCuUPNYwnqCY2eSfPmztEsng?sub_confirmation=1">
                <i className="fa-brands fa-youtube"></i>
            </a>
        </div>
    )
}

export default Socials